import { adminAxiosInstance } from "./axiosInstance";
import type { DashboardWidget } from "frontend-dashboard-contracts";

export type PortenType = "PULSE" | "HSEQ_DASHBOARD";

export type Product = {
    id: number;
    name: string;
    createdAt: string;
    type: string;
    compublishId: number;
    blockProduct: boolean;
    portenType?: PortenType;
};

export type ProductInstance = {
    name: string;
    id: number;
    productId: number;
    compublishId: number;
    url: string;
    newTemplate: boolean;
    slug: string;
    deletedAt: string | null;
    disabledAt: string | null;
    product?: Product;
    customerId: number;
    updatedById: number;
    portenType: PortenType | null;
};

export type { DashboardWidget } from "frontend-dashboard-contracts";

export type DashboardWidgetProvisioning = {
    widget: DashboardWidget;
    enabled: boolean;
};

interface ApiResponse<T> {
    data: T;
}

const getSubscribedProductsByCustomerId = async (
    customerId: number,
): Promise<ProductInstance[]> => {
    try {
        const response = (
            await adminAxiosInstance.get<ApiResponse<ProductInstance[]>>(
                `admin/product-instances/${customerId}`,
            )
        ).data;
        return response.data;
    } catch (err) {
        throw new Error(
            `Error fetching subscribed products: ${err instanceof Error ? err.message : err}`,
            { cause: err },
        );
    }
};

const getDashboardWidgets = async (instanceId: number): Promise<DashboardWidgetProvisioning[]> => {
    try {
        const response = (
            await adminAxiosInstance.get<ApiResponse<DashboardWidgetProvisioning[]>>(
                `admin/product-instances/${instanceId}/dashboard-widgets`,
            )
        ).data;
        return response.data;
    } catch (err) {
        throw new Error(
            `Error fetching dashboard widgets: ${err instanceof Error ? err.message : err}`,
            { cause: err },
        );
    }
};

export { getDashboardWidgets, getSubscribedProductsByCustomerId };
